// Constants
export const users = () => {
  return {
    users: {
      id: {
        description: 'id autoincrement',
        label: 'Id',
        readonly: true,
        type: 'number',
        dataform: ['admin_usuarios'],
        datatype: {
          predeterminate: ''
        }
      },
      name: {
        type: 'text',
        label: 'Nombres',
        name: 'dusNombre',
        placeholder: '',
        dataform: ['admin_usuarios'],
        description: 'nombres',
        prepend: '',
        append: '',
        validate: 'required',
        datatype: 
        {
          type: 'input',
          disabled: false,
          predeterminate: '',
        }
      },  
      email: {
        type: 'text',
        label: 'Email',
        dataform: ['admin_usuarios'],
        placeholder: '',
        description: 'correo electonico',
        validate: 'required',
        datatype: 
        {
          type: 'input',
          disabled: false,
          predeterminate: '',
        }
      },
      password: {
        type: 'text',
        label: 'Contraseña',
        dataform: ['admin_usuarios'],
        placeholder: '',
        description: 'correo electonico',
        validate: 'required',
        datatype: 
        {
          type: 'input',
          disabled: false,
          predeterminate: '',
        }
      },   
      permisos_modulos: {
        type: 'json',
        label: 'Contraseña',
        dataform: ['admin_usuarios'],
        placeholder: '',
        description: 'correo electonico',
        validate: '',
        datatype: 
        {
          type: 'json',
          predeterminate: {},
        }
      }, 
      permisos_campos: {
        type: 'json',
        label: 'Contraseña',
        dataform: ['admin_usuarios'],
        placeholder: '',
        description: 'correo electonico',
        validate: '',
        datatype: 
        {
          type: 'json',
          predeterminate: {},
        }
      }, 
    }
  }
}

export function asign_users(){
  var asign= Object.keys(users().users);
  var objeto = users().users
  var nuevoArray = {}
  for(var i=0; i<asign.length; i++)
  {
          var createdataform= objeto[asign[i]].dataform
          for(var j=0; j<createdataform.length;  j++)
          {
                  nuevoArray[createdataform[j]] = {}
          }
  }        
  return nuevoArray
}

